// @ts-check

import {
  createReportingDimension,
  deleteReportingDimension,
  getDimensions,
  updateReportingDimension
} from '@/api/reportingDimensions'

// Promise for loading dimensions
let loader = null

export const initReportingDimensionState = () => ({
  editing: false,
  saving: false,
  reportingDimensions: []
})

/** @type {import('vuex').GetterTree<any, any>} */
const reportingDimensionGetters = {
  reportingDimensions: (state) => {
    return state.reportingDimensions
  }
}

/** @type {import('vuex').MutationTree<any>} */
const reportingDimensionMutations = {
  addItem: (state, item) => {
    state.reportingDimensions.push(item)
  },
  setItems: (state, items) => {
    state.reportingDimensions = items
  },
  removeItem: (state, id) => {
    state.reportingDimensions = state.reportingDimensions.filter(
      (dimension) => dimension.id !== id
    )
  },
  updateItem: (state, item) => {
    const index = state.reportingDimensions.findIndex(
      (dimension) => dimension.id === item.id
    )
    state.reportingDimensions.splice(index, 1, item)
  }
}

/** @type {import('vuex').ActionTree<any, any>} */
const reportingDimensionActions = {
  getDimensions({ commit }) {
    // Have we started loading dimensions yet?
    if (!loader) {
      // No, start loading now
      loader = getDimensions().then(({ data: items }) => {
        commit('setItems', items)
      })
    }

    // Return promise so that caller can be notified upon completion
    return loader
  },

  /**
   * Creates a new reporting dimension (API + store).
   */
  async createReportingDimension({ commit }, payload) {
    const { data: createdItem } = await createReportingDimension(payload)
    commit('addItem', createdItem)

    return createdItem
  },

  /**
   * Updates a reporting dimension with the given id (API + store).
   */
  async updateReportingDimension({ commit }, { id, payload }) {
    const { data: updatedItem } = await updateReportingDimension(id, payload)
    commit('updateItem', updatedItem)

    return updatedItem
  },

  /**
   * Deletes a reporting dimension with the given id (API + store).
   */
  async deleteReportingDimension({ commit }, id) {
    await deleteReportingDimension(id)
    commit('removeItem', id)
  }
}

export const reportingDimensionModule = {
  namespaced: true,
  state: initReportingDimensionState,
  getters: reportingDimensionGetters,
  actions: reportingDimensionActions,
  mutations: reportingDimensionMutations
}

export default reportingDimensionModule
